export const instructionArticleUrl = '/article/one';
